/**
 * Phase 135B — /livex/replays/:id (authenticated detail page)
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '@/lib/api';
import LivexReplayPlayer from '@/components/livex/LivexReplayPlayer';
import { AlertTriangle, Loader2 } from 'lucide-react';

export default function LivexReplayDetail() {
  const { replayId } = useParams();
  const [replay, setReplay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    api.get(`/livex/replays/${replayId}`)
      .then((r) => active && setReplay(r.data))
      .catch((e) => active && setError(e.response?.data?.detail || 'Replay not found'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [replayId]);

  const handleShare = async () => {
    try { await api.post(`/livex/replays/${replayId}/share`); }
    catch { /* ignore */ }
  };

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-white" style={{ background: '#0a0a0f' }}>
        <Loader2 className="h-6 w-6 animate-spin text-[#FF5A1F]" />
      </div>
    );
  }
  if (error || !replay) {
    return (
      <div className="min-h-screen grid place-items-center text-white px-6" style={{ background: '#0a0a0f' }}>
        <div className="max-w-md text-center">
          <AlertTriangle className="h-12 w-12 mx-auto text-rose-400 mb-3" />
          <h1 className="text-xl font-black">Replay not found</h1>
          <p className="livex-body-text mt-2">{error || 'This replay may have been deleted or expired.'}</p>
        </div>
      </div>
    );
  }
  return <LivexReplayPlayer replay={replay} mode="private" onShare={handleShare} />;
}
